export default "__VITE_ASSET__B8jaOX3P__"